<template>
  <div>
    <PCHeaderBar v-if="!useIsMobile().value" />
    <div class="search-bar" v-else>
      <HomeSearch :isPreview="true" />
    </div>

    <div class="sitemap-list-wrapper" :data-mode="useIsMobile().value ? 'wap' : 'pc'">
      <ul class="nav-list">
        <li v-for="item in sitemapJSON" :key="item.key">
          <a :href="`#${item.key}`">{{ item.title }}</a>
        </li>
      </ul>

      <div v-if="!sitemapJSON" class="sitemap-list-not-data">
        Not Sitemap
      </div>
      <div
        v-else
        class="sitemap-list"
        v-for="(item, index) in sitemapJSON"
        :key="index"
      >
        <p class="sitemap-title" :id="item.key">{{ item.title }}</p>

        <RenderSub :subs="item.list || []"/>
      </div>
    </div>

    <template v-if="!useIsMobile().value">
      <LazyPCFooter />
      <LazyKCookiePopup />
    </template>

    <!-- 底部菜单 -->
    <KTabbar v-else />
  </div>
</template>

<script lang="tsx" setup>
import domain from '../server-config/domain.config'
import {getHotKeysJumpUrl} from "~/plugins/utils";

definePageMeta({layout: 'wap'})
const titleMap = {
  'categories': 'All Category',
  'hotKeywords': 'Hot search keywords',
  'promotions': 'Promotions'
}

interface ISub {
  name: string,
  url: string,
  children: ISub[]
}

const RenderSub = (props: { subs: ISub[] }) => {
  const {subs} = props

  return (
    <ul class="sitemap-subs">
      {
        subs.map((subItem, subIndex) => {
          if (subItem?.children?.length) {
            return (
              <li
                key={subIndex}
                class="sitemap-sub-item"
                style="width: 100%"
              >
                <p class="sub-item-title">
                  <a href={subItem.url} title={subItem.name} class="last-deep-a">{subItem.name}</a>
                </p>

                <RenderSub subs={subItem.children}/>
              </li>
            )
          } else {
            return (
              <li
                key={subIndex}
                class="sitemap-sub-item"
              >
                <a class="last-deep-a" href={subItem.url} title={subItem.name}>{subItem.name}</a>
              </li>
            )
          }
        })
      }
    </ul>
  )
}

const sitemapJSON = ref<any>([])
try {
  // 根据域名提取国家代码，与 sitemap-index.xml.get.ts 逻辑保持一致
  const host = useCurrentHost()
  const supportedCountries = ['ke', 'ug']
  const lowerHost = host.toLowerCase()
  const countryCode = supportedCountries.find(code => lowerHost.includes(`.${code}`) || lowerHost.includes(`/${code}`) || lowerHost.includes(`${code}-`)) || 'ke'
  const res = await fetch(`${domain.HW_OBS}/sitemap/${countryCode}/inside-sitemap.json`)
  const {categories, hotKeywords, promotions, channels} = await res.json()

  sitemapJSON.value = [
    {
      title: titleMap.categories,
      key: 'categories',
      list: categories
    },
    {
      title: titleMap.hotKeywords,
      key: 'hotKeywords',
      list: (hotKeywords || [])
        .filter((c: any) => [1, 2, 3, 5, 6, 10].includes(c.linkType))
        .map((c: any) => {
          return {
            name: c.name,
            url: getHotKeysJumpUrl(
              {linkType: c.linkType, linkValue: c.linkValue, keyword: c.name}
            ).href || useCurrentHost()
          }
        })
    },
    {
      title: titleMap.promotions,
      key: 'promotions',
      list: [...channels, ...promotions]
    }
  ]
} catch (e) {
  console.error(e)
}
</script>

<style lang="scss" scoped>

.sitemap-list-not-data {
  text-align: center;
  font-size: 38px;
  color: #999999;
  width: 100%;
  margin: 0 auto;
  padding: 200px 0;
}

.sitemap-list {
  background: #fff;
  padding: 80px 30px 0 80px;
}

.sitemap-title {
  font-size: 42px;
  font-weight: 600;
  border-bottom: 1px solid #cacaca;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.sitemap-list:deep(.sitemap-subs) {
  display: flex;
  flex-wrap: wrap;
  font-size: 26px;

  .sitemap-sub-item {
    margin-bottom: 30px;
  }

  .last-deep-a {
    margin-right: 40px;
    padding: 10px 0;
    display: inline-block;
    cursor: pointer;
    border-bottom: 1px solid transparent;

    &:hover {
      color: var(--main_color);
      border-bottom-color: var(--main_color);
    }
  }

  .sub-item-title {
    font-size: 36px;
    font-weight: 500;
    margin: 30px 0;
  }
}

.nav-list {
  height: 100px;
  line-height: 100px;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  li{
    font-size: 32px;
    padding-right: 40px;
    cursor: pointer;
    &:hover {
      color: var(--main_color);
      border-bottom-color: var(--main_color);
    }
    &:last-child::after{
      display: none;
    }
    &::after{
      content: " | ";
      color: #999999;
      margin-left: 40px;
    }
  }
}

.sitemap-list-wrapper[data-mode="pc"] {
  width: var(--viewport-width);
  padding-bottom: 100px;
  margin: 60px auto;
}
.sitemap-list-wrapper[data-mode="wap"] {
  height: calc(100vh - 100px - 110px);
  overflow-y: auto;
  width: 100%;
  // padding: 0 30px;
  .sitemap-list-wrapper,
  .sitemap-list-not-data{
    font-size: 26px;
  }
  .sitemap-list{
    padding: 30px;
    margin: 0;
  }

  .sitemap-list:deep(.sitemap-subs) {

    .sub-item-title{
      margin: 0 0 20px 0;
    }
    .sitemap-sub-item{
      margin-bottom: 20px;
    }
  }
  
  .nav-list {
    position: sticky;
    top: 0px;
    padding: 0 30px;
    background-color: #fff;
    z-index: 1;
    margin-bottom: 0;
    li{
      font-size: 24px;
      padding-right: 20px;
      white-space: nowrap;
      &::after{
        margin-left: 20px;
      }
    }
  }
}
</style>
